import { Link } from "react-router-dom";
import { Linkedin, Mail, MapPin, Phone } from "lucide-react";
import { SERVICES } from "../data/services";
import { useSettings } from "../hooks/useSettings";

export function SiteFooter() {
  const settings = useSettings();
  return (
    <footer data-testid="site-footer" className="grain relative bg-[var(--navy)] text-slate-300">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-16 sm:px-6 md:grid-cols-12 lg:px-8">
        <div className="md:col-span-4">
          <img src="/logo-white.png" alt="MarksMan Healthcare" className="h-20 w-auto" />
          <div className="eyebrow mt-4 !text-teal-300 !text-xs !tracking-[0.3em]">Evidence. Insights. Access.</div>
          <p className="mt-3 max-w-sm text-sm leading-relaxed text-slate-400">{settings?.tagline}</p>
          <div className="mt-6 space-y-2 text-sm">
            {settings?.email && <a href={`mailto:${settings.email}`} className="flex items-center gap-2 hover:text-white"><Mail size={15} /> {settings.email}</a>}
            {settings?.phone && <a href={`tel:${settings.phone.replace(/[^+\d]/g, "")}`} className="flex items-center gap-2 hover:text-white"><Phone size={15} /> {settings.phone}</a>}
            {settings?.linkedin && <a href={settings.linkedin} target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-white"><Linkedin size={15} /> LinkedIn</a>}
          </div>
        </div>
        <div className="md:col-span-3">
          <div className="eyebrow !text-teal-300">Capabilities</div>
          <ul className="mt-4 space-y-2 text-sm">
            {SERVICES.map((s) => <li key={s.slug}><Link to={`/services/${s.slug}`} className="hover:text-white">{s.name}</Link></li>)}
          </ul>
        </div>
        <div className="md:col-span-2">
          <div className="eyebrow !text-teal-300">Company</div>
          <ul className="mt-4 space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-white">About us</Link></li>
            <li><Link to="/platforms" data-testid="footer-platforms" className="hover:text-white">Platforms</Link></li>
            <li><Link to="/publications" className="hover:text-white">Publications</Link></li>
            <li><Link to="/academy" className="hover:text-white">MarksMan Academy</Link></li>
            <li><Link to="/careers" className="hover:text-white">Careers</Link></li>
            <li><Link to="/contact" className="hover:text-white">Contact</Link></li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <div className="eyebrow !text-teal-300">Offices</div>
          <ul className="mt-4 space-y-4 text-sm">
            {(settings?.offices || []).map((o) => <li key={o.country} className="flex items-start gap-2 text-slate-400"><MapPin size={15} className="mt-0.5 shrink-0 text-teal-300" /><span><span className="font-semibold text-slate-200">{o.country}</span><br />{o.address}</span></li>)}
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col gap-2 px-4 py-5 text-xs text-slate-500 sm:flex-row sm:items-center sm:justify-between sm:px-6 lg:px-8">
          <span>© {new Date().getFullYear()} MarksMan Healthcare Communications Pvt. Ltd. All rights reserved.</span>
          <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-slate-300">Team login</Link>
        </div>
      </div>
    </footer>
  );
}
